/**
 * Swoop Brand Constants
 * Official colors and assets from mobile app branding
 */

export const BRAND_COLORS = {
  // Primary cyan/turquoise accent (from sparkle in logo)
  cyan: {
    DEFAULT: '#38D1D8',
    light: '#4DD9E0',
    dark: '#2BB8BF',
  },
  // Dark/Black for primary elements
  dark: {
    DEFAULT: '#0F1419',
    light: '#1A1F26',
  },
} as const;

export const BRAND_ASSETS = {
  logo: {
    dark: '/images/swoop-logo-dark.png',
    white: '/images/swoop-logo-white.png',
  },
  icon: '/images/swoop-icon.png',
} as const;

